import {Binding, Spot} from 'gojs';

import {accessibleImpactScoreColor, impactScoreText} from 'src/util/impact-score';
import {col, row, text} from 'src/util/gojs/components';
import {colorSecondaryLightGray as TEXT_COLOR} from 'src/styles/colors';
import {margin} from 'src/util/gojs/utils';
import {promptFont} from 'src/util/gojs/styles/fonts';

import {makeToolTip} from '../tooltip';

export const impactScore = () =>
  col([
    {
      toolTip: makeToolTip('Calculated score based on complex code and dependencies collected about your application'),
    },
    new Binding('visible', 'data', ({properties}) => typeof properties['codelogic.quality.impactScore'] === 'number'),
    text([
      'IMPACT SCORE',
      {
        font: `${promptFont(0.75)}`,
        stroke: TEXT_COLOR,
        margin: margin(0, 0, 5),
      },
    ]),
    row([
      text([
        'n ',
        {
          font: `bold ${promptFont(1.2)}`,
        },
        new Binding('text', 'data', ({properties}) => impactScoreText(properties['codelogic.quality.impactScore'])),
        new Binding('stroke', 'data', ({properties}) => {
          const score = properties['codelogic.quality.impactScore'];
          return accessibleImpactScoreColor(score);
        }),

      ]),
      text([
        '/100',
        {
          alignment: Spot.Top,
          font: promptFont(0.5),
          margin: margin(0, 0, 0, 2),
        },
      ]),
    ]),
  ]);
